<ng-container *ngTemplateOutlet="data"></ng-container>
